import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'rebass'
import LoadingSpinner from '../../components/LoadingSpinner'
import { Heading } from 'rebass'
import { PropTypes } from 'prop-types'

const FlexWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.blue_light};
`

const ContentFrame = styled(Box)`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: ${(props) => props.theme.content.max.width};
  background-color: ${(props) => props.theme.colors.blue_light};
`

const OuterHeading = styled(Heading)`
  text-align: center;
`

const ContentRedirect = (props) => {
  return (
    <FlexWrapper flexWrap="wrap">
      <ContentFrame mt={[20, 50]}>
        <OuterHeading mb={[30]} mx={3}>
          {props.title || 'Redirecting...'}
        </OuterHeading>

        <LoadingSpinner />
      </ContentFrame>
    </FlexWrapper>
  )
}

ContentRedirect.propTypes = {
  title: PropTypes.string
}

export default ContentRedirect
